import { get } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { services } from '@/utils'

import squircle from '@/components/icon/squircle'

export default function(h) {
  const type = get(this.value, 'data.sending.type')

  return h(
    'div',
    {
      class: {
        [`${services.sendings}-tasks__type`]: true,
        [`${services.sendings}-tasks__type--${type}`]: true
      }
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: type,
            color: Colors[type],
            tooltip: this.getTranslate(`${services.sendings}.types.${type}`)
          }
        }
      )
    ]
  )
}
